import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { useAuthGuard, useMutation } from 'utils/hooks';
import { logout } from 'utils/services';
import { setAccessRefreshToken } from 'utils/services/auth';
import { IS_ALL_SSR } from 'dictionary';
import SSRLoggedOut from 'containers/SSRLoggedOut';
import ssImage from 'assets/ss-icons/shipstation-icon.png';

export default function SellerSignIn() {
  const { search } = useLocation();
  const { replace } = useHistory();
  const [hasError, setHasError] = useState(false);

  const { onAuthenticated } = useAuthGuard();

  const { redirect_path: redirectPath = '/', ...queryData } = qs.parse(search, {
    ignoreQueryPrefix: true
  });

  // Always redirect to configure page when REACT_APP_IS_ALL_SSR is true
  const finalRedirectPath = IS_ALL_SSR ? '/configure' : redirectPath;

  const { mutate: signIn } = useMutation('auth.sellerSignIn', 'POST', {
    payload: { ...(queryData || {}) },
    errorMessage: "We couldn't log you in.",
    onSuccess: res => {
      onAuthenticated(_get(res, 'data', {}), finalRedirectPath);
      setAccessRefreshToken(_get(res, 'refresh', ''));
    },
    onError: () => {
      if (IS_ALL_SSR) {
        setHasError(true);
      } else {
        replace('/login');
      }
    }
  });

  useEffect(() => {
    logout(() => signIn());
  }, [signIn]);

  if (hasError) {
    return <SSRLoggedOut />;
  }

  return (
    <div className={styles.container}>
      <img className={styles.ssImage} src={ssImage} alt="not found" />
    </div>
  );
}
